import { render, staticRenderFns } from "./ExpersRead.vue?vue&type=template&id=0f085283&"
import script from "./ExpersRead.vue?vue&type=script&lang=js&"
export * from "./ExpersRead.vue?vue&type=script&lang=js&"
import style0 from "./ExpersRead.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports